"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const base_analytics_provider_1 = require("./base-analytics-provider");
const Sentry = __importStar(require("@sentry/browser"));
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
const NumberOfSessionRecordingPercent = 5;
const SentryDsn = 'https://cdb773dfbdb05b8bb198c1a8f9ecf5aa@o4508199540555776.ingest.de.sentry.io/4510420687323216';
const MixpanelLogResponseFeatureFlag = 'mixpanel-log-response';
class NativeMixpanelProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(config) {
        var _a, _b, _c;
        super();
        this.isProfileReady = false;
        this.eventQueue = [];
        this.isShouldLogTrackErrors = false;
        this.onFeatureFlagsUpdate = () => {
            this.isShouldLogTrackErrors = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(MixpanelLogResponseFeatureFlag);
        };
        this.mixpanelInstance = mixpanel_browser_1.default;
        this.projectName = config.projectName;
        this.projectId = config.projectId;
        this.isSessionRecordingDisabled = (_a = config.isSessionRecordingDisabled) !== null && _a !== void 0 ? _a : false;
        this.isPageViewTrackingDisabled = (_b = config.isPageViewTrackingDisabled) !== null && _b !== void 0 ? _b : true;
        this.isAllowedAnonymousTracking = (_c = config.isAllowedAnonymousTracking) !== null && _c !== void 0 ? _c : false;
        this.initMixpanel();
        Sentry.init({
            dsn: SentryDsn,
            integrations: () => [],
            defaultIntegrations: false,
            autoSessionTracking: false,
            tracesSampleRate: 0
        });
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.on('update', this.onFeatureFlagsUpdate);
    }
    performLogout() {
        var _a;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.reset();
        this.isProfileReady = false;
        this.eventQueue = [];
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.off('update', this.onFeatureFlagsUpdate);
    }
    initMixpanel() {
        if (!this.isValidMixpanelConfig()) {
            console.warn('Mixpanel Project ID / Project name is not configured');
            return;
        }
        if (this.mixpanelInstance[this.projectName]) {
            this.isInitialized = true;
            return;
        }
        this.mixpanelInstance.init(this.projectId, {
            autocapture: false,
            record_sessions_percent: this.isSessionRecordingDisabled ? 0 : NumberOfSessionRecordingPercent,
            persistence: 'localStorage',
            record_idle_timeout_ms: 300000,
            record_block_selector: '[data-grammarly-shadow-root]',
            api_host: 'https://api-eu.mixpanel.com',
            verbose: true,
            ignore_dnt: true
        }, this.projectName);
        this.isInitialized = true;
    }
    isValidMixpanelConfig() {
        return Boolean(this.projectName && this.projectId);
    }
    trackPage() {
        var _a;
        if (this.isPageViewTrackingDisabled) {
            return;
        }
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.track_pageview();
    }
    identifyUser(identity) {
        var _a, _b, _c;
        if (!identity.id.length) {
            return;
        }
        const { id, name, email, firstName, lastName, phone, ...rest } = identity;
        const mixpanelSpecialProps = this.buildMixpanelSpecialProperties({ name, email, firstName, lastName, phone });
        const allUserProperties = { ...mixpanelSpecialProps, name, email, firstName, lastName, phone, ...rest };
        this.isProfileReady = false;
        this.eventQueue = [];
        this.userId = id;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.identify(id);
        (_c = (_b = this.mixpanelInstance[this.projectName]) === null || _b === void 0 ? void 0 : _b.people) === null || _c === void 0 ? void 0 : _c.set(allUserProperties, () => {
            this.isProfileReady = true;
            this.flushQueue();
            this.isShouldLogTrackErrors = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(MixpanelLogResponseFeatureFlag);
        });
    }
    track(eventName, properties) {
        var _a;
        if (!eventName || eventName.trim().length === 0) {
            console.warn('[NativeMixpanelProvider] Event name is required');
            return;
        }
        const hasNoUserId = !this.userId || this.userId.length === 0;
        if (hasNoUserId && !this.isAllowedAnonymousTracking) {
            return;
        }
        const trackOptions = this.getTrackOptions();
        if (this.isProfileReady || (hasNoUserId && this.isAllowedAnonymousTracking)) {
            (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.track(eventName, properties, trackOptions, response => {
                this.onTrackResponse(response, eventName, properties);
            });
        }
        else {
            this.eventQueue.push({ name: eventName, properties });
        }
    }
    updateUserIdentity(id, userProps) {
        var _a, _b;
        (_b = (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.people) === null || _b === void 0 ? void 0 : _b.set(userProps);
    }
    buildMixpanelSpecialProperties(props) {
        const specialProps = {};
        const mapping = [
            { source: 'name', target: '$name' },
            { source: 'email', target: '$email' },
            { source: 'firstName', target: '$first_name' },
            { source: 'lastName', target: '$last_name' },
            { source: 'phone', target: '$phone' }
        ];
        for (const { source, target } of mapping) {
            const value = props[source];
            if (value && value.length > 0) {
                specialProps[target] = value;
            }
        }
        return specialProps;
    }
    flushQueue() {
        var _a;
        while (this.eventQueue.length > 0) {
            const event = this.eventQueue.shift();
            if (event) {
                (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.track(event.name, event.properties);
            }
        }
    }
    onTrackResponse(response, eventName, eventProps) {
        if (!this.isShouldLogTrackErrors) {
            return;
        }
        let isSuccess = false;
        let errorMessage = '';
        const MIXPANEL_SUCCESS_STATUS = 1;
        if (typeof response === 'object' && response !== null && 'status' in response) {
            const status = response.status;
            isSuccess = status === MIXPANEL_SUCCESS_STATUS;
            errorMessage = isSuccess ? '' : `Response status: ${status}`;
        }
        else if (typeof response === 'number') {
            isSuccess = response === MIXPANEL_SUCCESS_STATUS;
            errorMessage = isSuccess ? '' : `Response status: ${response}`;
        }
        else {
            errorMessage = 'No valid response received from Mixpanel';
        }
        if (isSuccess) {
            Sentry.captureMessage(`Mixpanel track success for event: ${eventName}`, {
                level: 'info',
                extra: { properties: eventProps }
            });
            return;
        }
        Sentry.captureException(new Error(`Mixpanel tracking failed: ${errorMessage}`), {
            extra: {
                eventName,
                properties: eventProps,
                response
            }
        });
    }
    getTrackOptions() {
        if (this.isAllowedAnonymousTracking) {
            return { send_immediately: true, transport: 'sendBeacon' };
        }
        if (this.isShouldLogTrackErrors) {
            return { send_immediately: true };
        }
        return null;
    }
}
exports.default = NativeMixpanelProvider;
